import styled from "styled-components";

const Icon = styled.img`
  border-radius: 10px;
  border: 1px solid #d6dde8;
`;

export const PdtIcon = ({
  src,
  alt,
  size,
}: {
  src: string;
  alt: string;
  size: number;
}) => <Icon src={src} width={size} height={size} alt={alt} />;
